import React, { Suspense, lazy } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient'

const ReactQueryDevtools =
    process.env.NODE_ENV === 'development'
        ? lazy(() =>
              import('@tanstack/react-query-devtools').then((m) => ({
                  default: m.ReactQueryDevtools,
              }))
          )
        : null

export function ApiProvider({ children }) {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {ReactQueryDevtools ? (
                <Suspense fallback={null}>
                    <ReactQueryDevtools
                        initialIsOpen={false}
                        buttonPosition="bottom-right"
                    />
                </Suspense>
            ) : null}
        </QueryClientProvider>
    )
}

export default ApiProvider
